/* eslint-disable import/extensions */
import React from 'react';

import ImgPoint from '../../../../../assets/animation_point.gif';

import ImgStepC1 from '../../../../../assets/step-c-1.png';
import ImgStepC2 from '../../../../../assets/step-c-2.png';
import ImgStepC3 from '../../../../../assets/step-c-3.png';

import Img1 from '../../../../../assets/animation004-1.png';

import './animation004.less';
import './animation004.mobile.less';

const ImgStep = [ImgStepC1, ImgStepC2, ImgStepC3];

interface IStep {
  title: React.ReactNode | string;
  text: React.ReactNode | string;
  subStep?: React.ReactNode | string;
}

interface IAnimation004Props {
  title: React.ReactNode | string;
  steps: IStep[];
  onCompleted?: (() => void) | null;
  style?: React.CSSProperties;
  noIndicator?: boolean | null;
  className?: string;
}

const Animation004: React.FunctionComponent<IAnimation004Props> = ({
  title,
  steps,
  onCompleted,
  style,
  noIndicator,
  className,
}) => {
  const [step, setStep] = React.useState(1);
  const [subStepStatus, setSubStepStatus] =
    React.useState<Record<string, boolean>>();
  const nextStep = () => {
    const current = step;
    if (subStepStatus && subStepStatus[current] === false) {
      return;
    }

    setStep(current + 1);
    if (current >= steps.length - 1) {
      onCompleted && onCompleted();
    }
  };

  const handleSubStepClick = (event: Event, currentStep: number) => {
    if (event && currentStep) {
      const updatedStatus = Object.assign({}, subStepStatus);
      updatedStatus[currentStep] = true;
      setSubStepStatus(updatedStatus);
    }
  };

  React.useEffect(() => {
    const subStepStatusList: Record<string, boolean> = {};
    const subStepList: number[] = [];
    steps.forEach((i, index) => {
      if (i.subStep) {
        subStepStatusList[index + 1] = false;
        subStepList.push(index + 1);
      }
    });
    setSubStepStatus(subStepStatusList);

    const subTasks = document.querySelectorAll('.sub-task-text');
    if (subTasks) {
      subTasks.forEach((task, index) =>
        task.addEventListener('click', (event: Event) =>
          handleSubStepClick(event, subStepList[index])
        )
      );
      return () =>
        subTasks.forEach((task, index) =>
          task.removeEventListener('click', (event: Event) =>
            handleSubStepClick(event, subStepList[index])
          )
        );
    }
  }, []);

  const calcPointPosition = () => {
    const styles: Record<string, any> = {
      left:
        window.innerWidth > 1024
          ? step === 1
            ? '180px'
            : step === 2
            ? '410px'
            : '725px'
          : step === 1
          ? '20vw'
          : step === 2
          ? '45vw'
          : '65vw',
      opacity: step > steps.length - 1 ? 0 : 1,
    };
    if (window.innerWidth > 1024) {
      let bottom = step === 1 ? 18 : step === 2 ? 60 : 100;
      if (subStepStatus && subStepStatus[step] === false) {
        bottom += 150;
      }
      styles.bottom = `${bottom}px`;
    } else if (window.innerWidth > 480) {
      let bottom = step === 1 ? 0 : step === 2 ? 4 : 8;
      if (subStepStatus && subStepStatus[step] === false) {
        bottom = 10;
      }
      styles.bottom = `${bottom}vw`;
    } else {
      let bottom = step === 1 ? 7 : step === 2 ? 12 : 16;
      if (subStepStatus && subStepStatus[step] === false) {
        bottom = 20;
      }
      styles.bottom = `${bottom}vw`;
    }
    return styles;
  };

  return (
    <div
      className={`animation004 component ${className} ${
        !title ? 'no-title' : ''
      }`}
      style={{ ...style }}
    >
      {title && (
        <>
          <img className="img-g5584" width="214px" src={Img1} alt="" />
          {typeof title === 'string' ? (
            <div
              className="animation004-title"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          ) : (
            <div className="animation004-title">{title}</div>
          )}
        </>
      )}
      <div
        className="four-steps-section four-steps-section-1200"
        style={{ marginLeft: title ? '225px' : '8vw' }}
      >
        <img
          className="click-point"
          onClick={() => nextStep()}
          style={calcPointPosition()}
          src={ImgPoint}
          alt=""
        />
        {steps.map((itm, idx) => (
          <div
            key={idx}
            className={`step step${idx + 1} animation ${
              step > idx ? 'fade-in' : ''
            }`}
            onClick={() => nextStep()}
          >
            {!noIndicator &&
              (typeof itm.title === 'string' ? (
                <div
                  className="step-title"
                  dangerouslySetInnerHTML={{ __html: itm.title || '' }}
                />
              ) : (
                <div className="step-title">{itm.title}</div>
              ))}
            {typeof itm.text === 'string' ? (
              <div
                className="text"
                dangerouslySetInnerHTML={{ __html: itm.text || '' }}
              />
            ) : (
              <div className="text">
                {itm.text}
                {itm.subStep ? (
                  <div className="text sub-task-text">{itm.subStep}</div>
                ) : null}
              </div>
            )}

            {!noIndicator && <div className="indicator">0{idx + 1}</div>}
            {noIndicator && (
              <div className="indicator indicator-title">{itm.title}</div>
            )}
            {idx > 0 && (
              <img
                className={`${noIndicator ? 'no-indicator' : ''}`}
                src={ImgStep[idx - 1]}
                alt=""
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

Animation004.defaultProps = {
  onCompleted: null,
  style: {},
  noIndicator: false,
  className: undefined,
};

export default Animation004;
